export function registerServiceWorker(): void {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
    const swUrl = `${base}/sw.js`;
    navigator.serviceWorker.register(swUrl).catch(() => {
      /* ignore registration errors (e.g. unsupported, blocked) */
    });
  });
}
